export const SOCIAL_COUPON_REQUEST = 'SOCIAL_COUPON_REQUEST';
export const SOCIAL_COUPON_SUCCESS = 'SOCIAL_COUPON_SUCCESS';
export const SOCIAL_COUPON_FAILURE = 'SOCIAL_COUPON_FAILURE';

export const IDDAA = 'IDDAA';
export const MP = 'MP';
export const SPORTOTO = 'SPORTOTO';
export const TWITTER = 'TWITTER';
export const FACEBOOK = 'FACEBOOK';
export const WHATSAPP = 'WHATSAPP';
export const MAIL = 'MAIL';

export const TWITTER_URL = 'https://x.com/intent/tweet';
export const FACEBOOK_URL = 'https://www.facebook.com/sharer/sharer.php';
export const WHATSAPP_URL = 'https://api.whatsapp.com/send';